module.exports = __webpack_public_path__ + "static/media/play-button.d60e1483.svg";